import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { SingleColorType, ComponentStageType, IReduxState } from '../types';

import { colors } from '../constants';

import { setBackgroundColor } from '../redux/actions/backgroundColor';
import { nextStep, goToStep, resetSubStep } from '../redux/actions/step';

import { IntroView } from '../components/IntroView';

import { pushToDataLayer } from '../utils';

interface IProps {
    stepDisplayNumber: number;
    backButtonStepNumber: number;
    animationUrl?: string;
    headerText: string;
    subHeaderText?: string;
    tooltipText?: string;
    totalSteps: number;
    setBackgroundColorConnect(color: SingleColorType): void;
    setResetSubStepConnect(): void;
    onNextStep(): void;
    goToStepConnect(stepNumber: number): void;
    onCloseButtonClick?(): void;
}

export const BaseIntro: React.FC<IProps> = ({
    stepDisplayNumber,
    backButtonStepNumber,
    animationUrl,
    headerText,
    totalSteps,
    setBackgroundColorConnect,
    subHeaderText,
    onNextStep,
    goToStepConnect,
    onCloseButtonClick,
    tooltipText,
    setResetSubStepConnect,
}) => {
    const [componentStage, setComponentStage] = useState<ComponentStageType>(
        'enter'
    );

    useEffect(() => {
        setBackgroundColorConnect(colors.greenBg);
    });

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    });

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === 'ArrowRight') {
            handleNextButtonClick();
        }
    };

    const handleAnimationExit = () => {
        if (componentStage === 'exit') {
            onNextStep();
        }
    };

    const handleNextButtonClick = () => {
        pushToDataLayer(`${stepDisplayNumber}: ${headerText}`);
        setComponentStage('exit');
    };

    const handleStepBack = () => {
        setResetSubStepConnect();
        goToStepConnect(backButtonStepNumber);
    };

    return (
        <IntroView
            totalSteps={totalSteps}
            tooltipText={tooltipText}
            stepNumber={stepDisplayNumber}
            animationUrl={animationUrl}
            headerText={headerText}
            subHeaderText={subHeaderText}
            componentStage={componentStage}
            onAnimationExit={handleAnimationExit}
            onNextButtonClick={handleNextButtonClick}
            onBackButtonClick={handleStepBack}
            onCloseButtonClick={onCloseButtonClick}
        />
    );
};

const mapDispatchToProps = {
    setBackgroundColorConnect: setBackgroundColor,
    onNextStep: nextStep,
    goToStepConnect: goToStep,
    setResetSubStepConnect: resetSubStep,
};

export const Intro = connect(
    null,
    mapDispatchToProps
)(BaseIntro);
